import React, { useState, useRef, useEffect } from 'react';
import {
  ActiveListProvider,
  ShowListEditOptionProvider,
  ShowTaskEditOptionsProvider,
  TaskProvider,
  ListRefProvider,
  AllInOneProvider,
  ShowListEditBoxProvider,
  ShowTaskEditBoxProvider,
  DateTimeProvider,
  TargetListAddProvider,
  TargetListEditProvider,
} from '../context';
import {
  Header,
  ListBox,
  TaskBox,
  Core,
  ScreenAlerts,
  ListPage,
  TaskPage,
  Background,
} from '../components';
import {
  GridContainer,
  GridHeader,
  GridList,
  GridTask,
  ContentContainer,
} from './styles';
import { CSSTransition } from 'react-transition-group';
import { Desktop, Mobile } from '../media_queries';

export default function Dashboard() {
  const [showTasks, setShowTasks] = useState(false);
  const addListRef = useRef();
  const addTaskRef = useRef();
  const [height, setHeight] = useState();

  useEffect(() => {
    function handleHeight() {
      setHeight(window.innerHeight + 'px');
    }

    handleHeight();

    window.addEventListener('resize', handleHeight);
    return () => window.removeEventListener('resize', handleHeight);
  }, []);

  return (
    <>
      {false && (
        <Core.ForceAlert color={'#ea4e3d'} showBox={true} zIndex={999999}>
          Network disconnected (Might be offline or connection error)
        </Core.ForceAlert>
      )}

      <Background />

      <Desktop>
        <AllInOneProvider>
          <ActiveListProvider>
            <ListRefProvider>
              <TaskProvider>
                <ScreenAlerts />
                <GridContainer height={height}>
                  <GridHeader>
                    <Header />
                  </GridHeader>

                  <ContentContainer>
                    <ShowListEditOptionProvider>
                      <GridList>
                        <ListBox />
                      </GridList>
                    </ShowListEditOptionProvider>

                    <ShowTaskEditOptionsProvider>
                      <GridTask>
                        <TaskBox />
                      </GridTask>
                    </ShowTaskEditOptionsProvider>
                  </ContentContainer>
                </GridContainer>
              </TaskProvider>
            </ListRefProvider>
          </ActiveListProvider>
        </AllInOneProvider>
      </Desktop>

      <Mobile>
        <AllInOneProvider>
          <ActiveListProvider>
            <ListRefProvider>
              <TaskProvider>
                <ScreenAlerts />
                <GridContainer height={height}>
                  <ContentContainer>
                    <ShowListEditOptionProvider>
                      <ShowListEditBoxProvider>
                        <ShowTaskEditOptionsProvider>
                          <ShowTaskEditBoxProvider>
                            <DateTimeProvider>
                              <TargetListAddProvider>
                                <TargetListEditProvider>
                                  <Core.Slider
                                    showBox={showTasks}
                                    screen='Mobile'
                                  >
                                    <CSSTransition
                                      in={!showTasks}
                                      timeout={300}
                                      classNames='display'
                                    >
                                      <ListPage
                                        setShowTasks={setShowTasks}
                                        addListRef={addListRef}
                                        addTaskRef={addTaskRef}
                                      />
                                    </CSSTransition>
                                    <CSSTransition
                                      in={showTasks}
                                      timeout={300}
                                      classNames='display'
                                    >
                                      <TaskPage setShowTasks={setShowTasks} />
                                    </CSSTransition>
                                  </Core.Slider>
                                </TargetListEditProvider>
                              </TargetListAddProvider>
                            </DateTimeProvider>
                          </ShowTaskEditBoxProvider>
                        </ShowTaskEditOptionsProvider>
                      </ShowListEditBoxProvider>
                    </ShowListEditOptionProvider>
                  </ContentContainer>
                </GridContainer>
              </TaskProvider>
            </ListRefProvider>
          </ActiveListProvider>
        </AllInOneProvider>
      </Mobile>
    </>
  );
}
